import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { AuthPage } from "@tabipla/components";
import { useAuth } from "@/application/hooks/useAuth";

const MEKKE_THEME = {
  iconBg: "bg-indigo-500",
  iconText: "text-white",
  buttonClass: "bg-indigo-500 text-white shadow-lg hover:bg-indigo-600",
  backgroundGradient:
    "from-white via-gray-50 to-indigo-50/50 dark:from-gray-950 dark:via-gray-900 dark:to-indigo-950/30",
};

export function RegisterPage() {
  const { t } = useTranslation();
  const { register, loginWithLine, isLoading } = useAuth();

  return (
    <AuthPage
      appName={t("app.name")}
      tagline={t("app.tagline")}
      icon={<Sparkles className="h-8 w-8" />}
      theme={MEKKE_THEME}
      mode="register"
      onRegister={register}
      onLoginWithLine={loginWithLine}
      isLoading={isLoading}
    />
  );
}
